import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PhoneIcon from "@mui/icons-material/Phone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import InstagramIcon from "@mui/icons-material/Instagram";
import MailIcon from "@mui/icons-material/Mail";
import {
  faCss3Alt,
  faEnvira,
  faHtml5,
  faJava,
  faPython,
  faReact,
  faSquareJs,
} from "@fortawesome/free-brands-svg-icons";
import {
  faDatabase,
  faFileExcel,
  faFilePowerpoint,
} from "@fortawesome/free-solid-svg-icons";
import money_manager_1 from "./images/projects/money_manager_1.png";
import money_manager_2 from "./images/projects/money_manager_2.png";
import money_manager_3 from "./images/projects/money_manager_3.png";
import open_brewery_1 from "./images/projects/open_brewery_1.png";
import open_brewery_2 from "./images/projects/open_brewery_2.png";
import portfolio_1 from "./images/projects/portfolio_1.png";
import portfolio_2 from "./images/projects/portfolio_2.png";
import portfolio_3 from "./images/projects/portfolio_3.png";

const profileData = {
  "About Me": `A Governance & Delivery professional 👩🏻‍💻 currently working in Application Management & Analytics within a global enterprise environment.
My experience spans Portfolio Governance, CAP & compliance tracking, risk monitoring, and executive reporting — ensuring commitments stay visible, risks are addressed early, and leadership stays informed.
I enjoy bringing structure to complexity, coordinating across Application, Engineering, and Risk teams, and turning operational updates into clear, meaningful insights.
📌 Currently exploring AI Governance, Responsible AI, and intelligent systems that combine innovation with accountability.
🔎 Always learning, growing, and looking for ways to strengthen governance through data and emerging technologies.`,
  bio: `🎓Computer Science graduate driven by curiosity about how technology works behind the scenes. I’m particularly interested in the intersection of technology and governance, bringing structure to complexity while continuously learning and growing.🌟 I embrace challenges with discipline and clarity in every role I take on.`,
  hashtag: "#BeYourBestYou✨",
  quote: "Living, learning, & leveling up one day at a time.",
  Skillset: [
    {
      title: "Scripting language",
      content: {
        HTML: (
          <FontAwesomeIcon
            icon={faHtml5}
            style={{ color: "#db3a1a" }}
            size="2xl"
          />
        ),
        CSS: (
          <FontAwesomeIcon
            icon={faCss3Alt}
            style={{ color: "#114cb0" }}
            size="2xl"
          />
        ),
      },
    },
    {
      title: "Programming Language",
      content: {
        Javascript: (
          <FontAwesomeIcon
            icon={faSquareJs}
            style={{ color: "#d9c812" }}
            size="2xl"
          />
        ),
        Java: (
          <FontAwesomeIcon
            icon={faJava}
            style={{ color: "#d15d10" }}
            size="2xl"
          />
        ),
        Python: (
          <FontAwesomeIcon
            icon={faPython}
            style={{ color: "#5077b9" }}
            size="2xl"
          />
        ),
      },
    },
    {
      title: "Javascript library",
      content: {
        "React JS": (
          <FontAwesomeIcon
            icon={faReact}
            style={{ color: "#2bc9de" }}
            size="2xl"
          />
        ),
      },
    },
    {
      title: "DataBase",
      content: {
        SQL: (
          <FontAwesomeIcon
            icon={faDatabase}
            style={{ color: "#0d234a" }}
            size="2xl"
          />
        ),
        MongoDB: (
          <FontAwesomeIcon
            icon={faEnvira}
            style={{ color: "#328633" }}
            size="2xl"
          />
        ),
      },
    },
    {
      title: "MS Office",
      content: {
        "MS Excel": (
          <FontAwesomeIcon
            icon={faFileExcel}
            style={{ color: "#2da45b" }}
            size="2xl"
          />
        ),
        "MS Powerpoint": (
          <FontAwesomeIcon
            icon={faFilePowerpoint}
            style={{ color: "#d05706" }}
            size="2xl"
          />
        ),
      },
    },
  ],
  "Additional Skills": [
    "Communication skills",
    "Team work & Collaboration",
    "Quick Learner",
    "Time Management",
    "Analytical Thinking & Problem Solving",
    "Flexible & Adaptible",
  ],
  Projects: [
    {
      description:
        "Money manager is a web application where user can maintain & track their expenses/income across various categories with profile/account created.",
      image: [money_manager_1, money_manager_2, money_manager_3],
      title: "Money Manager",
      techStack: [
        "Javascript",
        "HTML & CSS",
        "React",
        "MongoDB",
        "Express",
        "Node JS",
      ],
      deployedUrl: "",
      gitUrl: "",
    },
    {
      description:
        "Web Application to search & display the brewery details with Open Brewery API.",
      image: [open_brewery_1, open_brewery_2],
      title: "Open Brewery",
      techStack: ["Javascript", "HTML & CSS", "Bootstrap"],
      deployedUrl: "",
      gitUrl: "https://github.com/NivedithaSekar/Open-Brewery",
    },
    {
      description: "Website developed and maintained to showcase my portfolio!",
      image: [portfolio_1, portfolio_2, portfolio_3],
      title: "Portfolio",
      techStack: ["Javascript", "HTML & CSS", "React"],
      deployedUrl: "",
      gitUrl: "",
    },
  ],
  Contact: [
    {
      key: "mail",
      link: "mailto:niveditha.spnk@gmail.com",
      icon: <MailIcon />,
    },
    {
      key: "github",
      link: "https://github.com/NivedithaSekar",
      icon: <GitHubIcon />,
    },
    {
      key: "linkedIn",
      link: "https://www.linkedin.com/in/niveditha-sekar-65711a104/",
      icon: <LinkedInIcon />,
    },
    { key: "phone", link: "tel:+919876543210", icon: <PhoneIcon /> },
    {
      key: "instagram",
      link: "https://www.instagram.com/_niveditha_s_/",
      icon: <InstagramIcon />,
    },
  ],
};

export default profileData;
